import React from "react"
import { RouterProvider } from "@tanstack/react-router"
import { router } from "./router"

/**
 * Root application component that mounts the TanStack Router provider.
 *
 * @returns The routed React tree for the peer assessment experience.
 */
const App: React.FC = () => {
  return <RouterProvider router={router} />
}

export default App
